import connectionProxy from '../connectionProxy'

export const getClassrooms = (building) => {
  return connectionProxy.get(`classrooms?building=${building}`)
}
